module.exports = __webpack_public_path__ + "img/Digibank by DBS.48518dc9.png";